import { useSelector } from "react-redux";
import { RootState } from "types";
import SystemAdminDashboard from "./dashboards/SystemAdministratorDashboard";

function Dashboard() {
  const user = useSelector((state: RootState) => state.auth.user);

  if (!user) return <></>;

  return <SystemAdminDashboard />;
}

export default Dashboard;
